<p-card *ngIf="!done" header="Bestellung einreichen" [style]="{'width': '400px', 'margin': 'auto'}">
    <div class="grid">
        <p-card class="col-12">
            <sm-form [form]="form">
            </sm-form>
        </p-card>
        <div class="col-12" style="text-align: left">
            <p-button icon="fas fa-paper-plane" label="Abschicken" (onClick)="send()">
            </p-button>
        </div>
     </div>

</p-card>

<p-card *ngIf="done" header="Vielen Dank" [style]="{'width': '400px', 'margin': 'auto'}">
    Ihre Bestellung wurde eingereicht
</p-card>
